import MapaMundi from "../../imagens/worldMap/simpleMap.png"
import "./globalMap.css"
import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons"

const imagePaths = {
    "EUA": require('../../imagens/worldMap/EUA.png'),
    "Spain": require('../../imagens/worldMap/spain.png'),
    "Brazil": require('../../imagens/worldMap/Brazil.png'),
    "BrazilMap": require("../../imagens/worldMap/brazilMap.png"),
    "EUAMap": require("../../imagens/worldMap/EUAMap.png"),
    "SpainMap": require("../../imagens/worldMap/SpainMap.png")
};

function GlobalMap() {
    const [hoveredArea, setHoveredArea] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [mapImage, setMapImage] = useState(MapaMundi);
    const imageRef = useRef(null);
    const originalCoords = useRef({
        EUA: "150,260,320,150",
        Spain: "550,250,400,50",
        Brazil: "270,400,390,280"
    });

    useEffect(() => {
        const updateCoords = () => {
            const img = imageRef.current;
            if (img) {
                const widthRatio = img.offsetWidth / img.naturalWidth;
                const heightRatio = img.offsetHeight / img.naturalHeight;
                const updateAreaCoords = (areaName) => {
                    const coords = originalCoords.current[areaName].split(',').map(Number);
                    const newCoords = coords.map((coord, index) => (
                        index % 2 === 0 ? coord * widthRatio : coord * heightRatio
                    ));
                    document.querySelector(`area[alt="${areaName}"]`).coords = newCoords.join(',');
                };

                updateAreaCoords("EUA");
                updateAreaCoords("Spain");
                updateAreaCoords("Brazil");
            }
        };

        window.addEventListener('resize', updateCoords);

        if (imageRef.current.complete)
            updateCoords(); // Update initially

        return () => {
            window.removeEventListener('resize', updateCoords);
        };
    }, []);

    const handleOpenModal = (image) => {
        setSelectedImage(image);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleMouseEnter = (area) => {
        setHoveredArea(area);
        setMapImage(imagePaths[area]);
    };

    const handleMouseLeave = () => {
        setHoveredArea(null);
        setMapImage(MapaMundi);
    };


    return (
        <div className="mapaMundiContainer container-fluid">
            {openModal && (
                <div className="globalMapSliderWrap">
                    <FontAwesomeIcon icon={faCircleXmark} className="globalMapBtnClose" onClick={handleCloseModal} />
                    <img className="EUAFullScreen img-fluid" src={selectedImage} alt="Global Map" />
                </div>
            )}
            <div>
                <img
                    className="img-fluid"
                    ref={imageRef}
                    src={mapImage}
                    alt="Imagem"
                    useMap="#imagem-map"
                />
                <map name="imagem-map">
                    <area
                        shape="rect"
                        coords="150,260,320,150"
                        href="#"
                        alt="EUA"
                        onClick={() => handleOpenModal(imagePaths["EUA"])}
                        onMouseEnter={() => handleMouseEnter('EUAMap')}
                        onMouseLeave={handleMouseLeave}
                    />
                    <area
                        shape="rect"
                        coords="550,250,400,50"
                        href="#"
                        alt="Spain"
                        onClick={() => handleOpenModal(imagePaths["Spain"])}
                        onMouseEnter={() => handleMouseEnter('SpainMap')}
                        onMouseLeave={handleMouseLeave}
                    />
                    <area
                        shape="rect"
                        coords="270,400,390,280"
                        href="#"
                        alt="Brazil"
                        onClick={() => handleOpenModal(imagePaths["Brazil"])}
                        onMouseEnter={() => handleMouseEnter('BrazilMap')}
                        onMouseLeave={handleMouseLeave}
                    />
                </map>
            </div>
        </div>
    );
}
export default GlobalMap